<template>
  <PopoverPortal v-if="isTouchPointer">
    <PopoverContent v-bind="{ ...forwarded, ...$attrs }" :class="cn(contentClass, props.class)">
      <slot />
    </PopoverContent>
  </PopoverPortal>
  <TooltipPortal v-else>
    <TooltipContent v-bind="{ ...forwarded, ...$attrs }" :class="cn(contentClass, props.class)">
      <slot />
    </TooltipContent>
  </TooltipPortal>
</template>

<script setup lang="ts">
import { cn } from "@/components/ui/utils"
import {
  PopoverContent,
  PopoverPortal,
  TooltipContent,
  type TooltipContentEmits,
  type TooltipContentProps,
  TooltipPortal,
  useForwardPropsEmits
} from "reka-ui"
import { useMediaQuery } from "@vueuse/core"
import { computed, type HTMLAttributes } from "vue"

defineOptions({
  inheritAttrs: false
})

const props = withDefaults(defineProps<TooltipContentProps & { class?: HTMLAttributes["class"] }>(), {
  sideOffset: 4
})

const emits = defineEmits<TooltipContentEmits>()

const isTouchPointer = useMediaQuery("(hover: none) and (pointer: coarse)")

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)

const contentClass =
  "tw-z-50 tw-overflow-hidden tw-rounded-md tw-border tw-bg-popover tw-px-3 tw-py-1.5 tw-text-sm tw-text-popover-foreground tw-shadow-md tw-animate-in tw-fade-in-0 tw-zoom-in-95 data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=closed]:tw-zoom-out-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2"
</script>
